"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
const SpinnerContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SpinnerContainer",
  class: "pl-s1sbubql",
  vars: {
    "s1sbubql-1": [({
      centerHorizontally
    }) => centerHorizontally ? '100%' : '']
  }
});
const StyledSpinner = /*#__PURE__*/(0, _react2.styled)(_spinner.default)({
  name: "StyledSpinner",
  class: "pl-s6q222p"
});

/**
 * Spinner Component.
 *
 * @param {Object} props React props
 * @param {Object} props.ariaLabels String in Object SpinnerName
 * @param {String} props.className ClassName default 'spin-center'
 * @param {Boolean} props.centerHorizontally Center spinner horizontally
 * @param {String} props.size Size of Spinner Default Md
 * @returns {React.ReactElement} Spinner Component
 * @public
 */

function Spinner({
  _name,
  size = 'md',
  centerHorizontally,
  ariaLabels = {
    spinnerName: 'Your content is loading...'
  },
  className,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(SpinnerContainer, (0, _extends2.default)({
    "data-cy": "spinner",
    centerHorizontally: centerHorizontally
  }, _patternLibraryUtils.tracking.create(_name, false, true)), /*#__PURE__*/_react.default.createElement(StyledSpinner, (0, _extends2.default)({}, rest, {
    size: size,
    ariaLabels: ariaLabels,
    className: className
  })));
}
var _default = exports.default = Spinner;
Spinner.propTypes = {
  _name: _propTypes.default.string,
  size: _propTypes.default.oneOf(['lg', 'md', 'sm']),
  centerHorizontally: _propTypes.default.bool,
  ariaLabels: _propTypes.default.object,
  className: _propTypes.default.string,
  ..._spinner.default.propTypes
};